/* ===========================================================
   Docs Protocol — boot

   public/boot.js has already painted the last-used colours. Here:
   start the router, read who's signed in (cached first, so it opens
   instantly and offline), draw the app, register the service worker.
   =========================================================== */

import { render } from 'preact';
import './styles/app.css';
import './styles/wp-look.css';   // Weather Protocol's look (after app.css so it wins)
import './styles/notes.css';   // Notes Protocol's cards
import './styles/tasks.css';   // Updates doc: Tell Claude tab
import { App } from './app.jsx';
import { startRouter } from './lib/router.js';
import { loadSession, deviceId } from './state.js';
import { toast } from './ui/ui.jsx';

deviceId();
startRouter();
loadSession();
render(<App />, document.getElementById('app'));
document.getElementById('boot')?.remove();

if ('serviceWorker' in navigator && location.hostname !== '127.0.0.1') {
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.register('/sw.js').then(r => r.update()).catch(err => console.warn('[sw] not registered', err));
  // a new version just arrived: off a doc, reload quietly; in a doc, offer it (never mid-typing)
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController) return;
    if (!location.pathname.startsWith('/d/')) location.reload();
    else import('./ui/ui.jsx').then(m => m.toast('A new version of Docs is ready.', { ms: 20000, action: { label: 'Reload', run: () => location.reload() } }));
  });
} else if ('serviceWorker' in navigator && new URLSearchParams(location.search).has('sw')) {
  navigator.serviceWorker.register('/sw.js');
}

// a real bug anywhere gets Proto with his wrench, not a silent failure
let lastError = 0;
window.addEventListener('error', e => {
  if (!e.filename || Date.now() - lastError < 4000) return;   // cross-origin "Script error." from extensions
  lastError = Date.now();
  toast(e.error || e.message, { kind: 'error' });
});
window.addEventListener('unhandledrejection', e => {
  const r = e.reason;
  if (!r || r.name === 'AbortError' || Date.now() - lastError < 4000) return;
  lastError = Date.now();
  console.error(r);
  toast(r, { kind: 'error' });
});
